import { render, staticRenderFns } from "./PlatformManagerLandingPage.vue?vue&type=template&id=b1fb6d70&"
import script from "./PlatformManagerLandingPage.vue?vue&type=script&lang=js&"
export * from "./PlatformManagerLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports